import { type Dispatch, type SetStateAction } from "react";
import { useContent } from "contexts/contentContext/contentContext";
import useInbox from "hooks/useInbox.ts";
import SelectElement from "../../../Elements/SelectElement/SelectElement";
import Icon from "../../../Elements/Icon/Icon";

type SubUserListT = {
  [id: string]: {
    SubUserEmail: string;
    SubUserFullName: string;
  };
};

interface SubUsersFilterI {
  setSelectedSubUser: Dispatch<SetStateAction<string[] | undefined>>;
  selectedSubUser: string[] | undefined;
}

/**
 * Renders a filter component for selecting sub-users.
 */

const SubUsersFilter = (props: SubUsersFilterI) => {
  const { setSelectedSubUser, selectedSubUser } = props;
  const { getTextByKey } = useContent();
  const { getSubUserList } = useInbox();
  const subUserList: SubUserListT = getSubUserList() as unknown as SubUserListT;

  return Object.keys(subUserList)?.length ? (
    <div className="sub-user-list-wrapper">
      {selectedSubUser ? (
        <Icon
          name="close"
          showTitle
          iconClass="remove-selected-sub-user-icon"
          title="remove-selected-sub-user"
          onClick={() => setSelectedSubUser([])}
        />
      ) : null}
      <SelectElement
        item={selectedSubUser}
        setItem={setSelectedSubUser}
        list={Object.values(subUserList).map((subUser) => subUser.SubUserEmail)}
        title={getTextByKey("select-sub-user")}
      />
    </div>
  ) : null;
};

export default SubUsersFilter;
